import DashboardLayout from "#/components/ui/DashboardLayout";
import { AssistantPage } from "#/pages/Assistant";
import ClientDetailPage from "#/pages/ClientDetail";
import ClientsPage from "#/pages/clients";
import DashboardPage from "#/pages/Dashboard";
import DataHealthPage from "#/pages/datahealth";
import ReportsPage from "#/pages/reports";
import ClientDeviceDetailPage from "#/pages/ClientDeviceDetail";
import DeviceDetailPage from "#/pages/DeviceDetail";
import DevicesPage from "#/pages/devices";
import ItemDetailPage from "#/pages/itemdetail";
import ItemsPage from "#/pages/items";
import LoginPage from "#/pages/login";
import PredictedDeliveriesPage from "#/pages/predicteddeliveries";
import ShipmentDetailPage from "#/pages/predicteddeliveries/shipmentdetail";
import ProductDetailPage from "#/pages/productdetail";
import ProductsPage from "#/pages/products";
import RegisterPage from "#/pages/Register";
import RfidTagsPage from "#/pages/rfidtags";
import ShipmentLogDetailPage from "#/pages/shipmentlogdetail";
import ShipmentManifestDetailPage from "#/pages/shipmentmanifestdetail";
import ShipmentManifestsPage from "#/pages/shipmentmanifests";
import ShipmentLogsPage from "#/pages/SiteDetail/shipmentlogs";
import SiteDetailPage from "#/pages/SiteDetail";
import SitesPage from "#/pages/sites";
import SubClientDetailPage from "#/pages/SubClientDetail";
import SubClientsPage from "#/pages/subclients";
import TemplateDetailPage from "#/pages/templatedetail";
import TemplatesPage from "#/pages/templates";
import TicketsPage from "#/pages/ticketmanagement";
import ClientMismatchPage from "#/pages/ClientMismatch";
import UnauthorizedPage from "#/pages/Unauthorized";
import VehicleDetailPage from "#/pages/vehicledetail";
import VehicleModelDetailPage from "#/pages/vehiclemodeldetail";
import VehicleModelsPage from "#/pages/vehiclemodels";
import VehiclesPage from "#/pages/vehicles";
import VerifyEmailPage from "#/pages/VerifyEmail";
import DebugSentryPage from "#/pages/DebugSentry";
import { Route, Routes, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { useAuth } from "#/hook/useAuth";
import { UserRole } from "#/types/user";
import { getFirstAllowedRoute } from "#/utils/routeUtils";

function IndexRedirect() {
  const { user } = useAuth();

  if (user?.role === UserRole.ADMIN) {
    return <Navigate to="/clients" replace />;
  }

  const redirectTo = getFirstAllowedRoute(user?.client?.allowedRoutes);
  return <Navigate to={redirectTo} replace />;
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/debug-sentry" element={<DebugSentryPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/verify" element={<VerifyEmailPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      <Route path="/client-mismatch" element={<ClientMismatchPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<IndexRedirect />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="clients/:id" element={<ClientDetailPage />} />
        <Route path="clients/:clientId/devices/:deviceId" element={<ClientDeviceDetailPage />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="t-rex" element={<AssistantPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="sites" element={<SitesPage />} />
        <Route path="sites/:id" element={<SiteDetailPage />} />
        <Route path="sub-clients" element={<SubClientsPage />} />
        <Route path="sub-clients/:id" element={<SubClientDetailPage />} />
        <Route path="devices" element={<DevicesPage />} />
        <Route path="devices/:id" element={<DeviceDetailPage />} />
        <Route path="ticket-management" element={<TicketsPage />} />
        <Route path="inventory/items" element={<ItemsPage />} />
        <Route path="inventory/items/:id" element={<ItemDetailPage />} />
        <Route path="inventory/categories" element={<ProductsPage />} />
        <Route path="inventory/categories/:id" element={<ProductDetailPage />} />
        <Route path="inventory/templates" element={<TemplatesPage />} />
        <Route path="inventory/templates/:id" element={<TemplateDetailPage />} />

        <Route path="fleet/models" element={<VehicleModelsPage />} />
        <Route path="fleet/models/:id" element={<VehicleModelDetailPage />} />
        <Route path="fleet/vehicles" element={<VehiclesPage />} />
        <Route path="fleet/vehicles/:id" element={<VehicleDetailPage />} />
        <Route path="fleet/logs" element={<ShipmentLogsPage />} />
        <Route path="fleet/logs/:id" element={<ShipmentLogDetailPage />} />
        <Route path="fleet/predicted-deliveries" element={<PredictedDeliveriesPage />} />
        <Route path="fleet/predicted-deliveries/shipments/:id" element={<ShipmentDetailPage />} />
        <Route path="fleet/shipment-manifests" element={<ShipmentManifestsPage />} />
        <Route path="fleet/shipment-manifests/:id" element={<ShipmentManifestDetailPage />} />

        <Route path="rfid-tags" element={<RfidTagsPage />} />
        <Route path="data-health" element={<DataHealthPage />} />
      </Route>
    </Routes>
  );
}
